import React, {Component} from 'react';

class WrapperContentFromArticleForPopup extends Component {
    render() {
        return (
            <div className="mb-2 article-wrapper-note"
                 dangerouslySetInnerHTML={{__html: this.props.note}}
            />
        );
    }
}

export default WrapperContentFromArticleForPopup;